import React from 'react';
import createClass from 'create-react-class';
import moment from 'moment';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

import ReservationStore from '../../../stores/ReservationStore';
import PaymentStore from '../../../stores/PaymentStore';
import { ReactComponent as InfoIcon } from '@/img/reservation_page/info.svg';
import Poller from '../../../utils/Poller';
import { Config } from 'arbitrip-common/client/utils';
import { CREDIT_GUARD_URL_VALIDITY_SECONDS } from 'arbitrip-common/general/constants';
import PaymentActions from '../../../actions/PaymentActions';
import { isElalCompany, isIsracardCompany } from '@/utils/isCompany';

const credit_card_url_state_path = 'paymentData.creditCardUrl';
const cg_regex = new RegExp('creditguard'); // for different iframe height component e.g. https://ppsuat.creditguard.co.il?txId=403204ef-4efe-484d-94c7-f1a9bc5561ac

const CREDIT_GUARD_EXPIRY_MS = CREDIT_GUARD_URL_VALIDITY_SECONDS * 1000;

function getCreditCardComponentState() {
	return {
		reservationData: ReservationStore.getReservationData(),
		paymentData: PaymentStore.getPaymentData(),
		didBook: false,
	};
}

const CreditCardComponent = createClass({
	displayName: 'CreditCardComponent',

	getInitialState: function () {
		return getCreditCardComponentState();
	},

	componentDidMount: function () {
		const credit_card_url_exists = _.get(this.state, credit_card_url_state_path);
		if (credit_card_url_exists) {
			Poller.startPaymentStatusPolling(this.props.couponValidation);
		}
		this._startCreditGuardExpiryTimerIfNeeded();

		window.addEventListener('message', this._onIframeMessage);
		ReservationStore.addChangeListener(this._onChange);
		PaymentStore.addChangeListener(this._onChange);
	},

	componentDidUpdate: function (prevProps, prevState) {
		const prevUrl = _.get(prevState, credit_card_url_state_path);
		const currentUrl = _.get(this.state, credit_card_url_state_path);

		if (prevUrl !== currentUrl) {
			this._clearCreditGuardExpiryTimer();
			this._startCreditGuardExpiryTimerIfNeeded();
			if (currentUrl) {
				Poller.startPaymentStatusPolling(this.props.couponValidation);
			}
		}
	},

	componentWillUnmount: function () {
		this._clearCreditGuardExpiryTimer();
		Poller.stopPaymentStatusPolling();
		PaymentActions.clearPaymentData();

		window.removeEventListener('message', this._onIframeMessage);
		PaymentStore.removeChangeListener(this._onChange);
		ReservationStore.removeChangeListener(this._onChange);
	},

	_clearCreditGuardExpiryTimer: function () {
		if (this._creditGuardExpiryTimer) {
			clearTimeout(this._creditGuardExpiryTimer);
			this._creditGuardExpiryTimer = null;
		}
	},

	_startCreditGuardExpiryTimerIfNeeded: function () {
		const url = _.get(this.state, credit_card_url_state_path);
		const onExpired = this.props.onPaymentLinkExpired;
		if (!url || !cg_regex.test(url) || !_.isFunction(onExpired)) {
			return;
		}
		this._clearCreditGuardExpiryTimer();
		this._creditGuardExpiryTimer = setTimeout(() => {
			this._creditGuardExpiryTimer = null;
			onExpired();
		}, CREDIT_GUARD_EXPIRY_MS);
	},

	getIframeClass: function () {
		let addedAttribute = '';
		const cg = cg_regex.test(this.state.paymentData.creditCardUrl);
		if (cg) {
			addedAttribute = ' cg;';
			if (_.get(this.props, 'profile.company.settings.enable_creditguard_3ds_terminal', false)) {
				addedAttribute = ' cxl'; // We need place for the number of installments
			} else if (_.get(this.props, 'profile.company.settings.installments_iframe_enabled', false)) {
				addedAttribute = ' ci'; // We need place for the number of installments
			}
		}
		if (Config.htz) {
			addedAttribute = ' htz';
		}
		return `iframe-container${addedAttribute}`;
	},
	renderIsracardBanner: function() {
		const {t, i18n} = this.props;
		return <div key="isracard-banner" className={`isracard-payment-banner ${i18n.dir().toString()}`}>
  				<div className="banner-tooltip-icon"><InfoIcon/></div>
  				<div className="banner-content" >
    				<div className="banner-title">{t('PleaseNotice')}</div>
    				<div className="banner-body">{t('OrderCanBeCompletedOnly')}</div>
  				</div>
			</div>
	},
	renderPaymentBanner: function() {
		const {t, i18n} = this.props;

		return <div key="payment-banner" className={`payment-banner ${i18n.dir().toString()}`}>
  				<div className="banner-tooltip-icon"><InfoIcon/></div>
  				<div className="banner-content" >
    				<div className="banner-title">{t('PaymentBanner.Title')}</div>
    				<div className="banner-body">{t('PaymentBanner.Body')}</div>
  				</div>
			</div>
	},
	getChargeDateText: function() {
		if (isIsracardCompany() || isElalCompany()) return null;
		const { t } = this.props;
		let charge_date_text;
		if (this.props.isBnpl) {
			return null;
		} else {
			charge_date_text = t('YourCardWillBeChargedImmediately');
			const charge_date = moment(this.state.reservationData.if_credit_card_charge_date);
			if (charge_date.diff(moment(), 'hours') > 24) {
				const sum_in_charge_currency = _.get(this.state.paymentData, 'sum_in_charge_currency');
				const charge_currency = _.get(this.state.paymentData, 'charge_currency');
				if (sum_in_charge_currency && sum_in_charge_currency) {
					charge_date_text = t('YourCardWillBeChargedAmount', {
						amount: sum_in_charge_currency,
						currency: charge_currency,
						date: charge_date.format('DD MMM YYYY'),
					});
				} else {
					charge_date_text = t('YourCardWillBeChargedOn', {
						credit_card_charge_date: charge_date.format('DD MMM YYYY'),
					});
				}
			}
		}
		return charge_date_text;
	},
	render: function () {
		// TODO: utilize private mode if needed
		// let private_mode = this.props.mode === "private";
		const iframe_container_class = this.getIframeClass();
		return (
			<div className="credit-card-component">
				{this.state.paymentData.creditCardUrl
					? [
							<div key="cccd" className="credit-card-charge-date">
								{this.getChargeDateText()}
							</div>,
							isIsracardCompany() && this.renderIsracardBanner(),
							isElalCompany() && !this.props.isBnpl && this.renderPaymentBanner(),
							<div key="ccif" className={iframe_container_class}>
								<iframe
									title="credit-card-iframe"
									id="credit-card-iframe"
									src={this.state.paymentData.creditCardUrl}
									frameBorder="0"
									scrolling="no"
									width="100%"
									height="100%"
								></iframe>
							</div>,
						]
					: null}
				{/*<div className="info-container"></div>*/}
			</div>
		);
	},

	_onIframeMessage: function (event) {
		if (event.data && event.data.type === 'PAYMENT_RETRY') {
			const paymentUrl = _.get(this.state, credit_card_url_state_path);
			if (paymentUrl) {
				const iframe = document.getElementById('credit-card-iframe');
				if (iframe) {
					iframe.src = paymentUrl;
				}
			}
		}
	},

	_onChange: function () {
		this.setState(getCreditCardComponentState());
	},
});

export default withTranslation()(CreditCardComponent);
